import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { SkeletonConfig } from "../../models/skeleton-config.model";

@Component({
  selector: 'app-skeleton-block-loader',
  standalone: true,
  templateUrl: './skeleton-block-loader.component.html',
  styleUrl: './skeleton-block-loader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SkeletonBlockLoaderComponent {
  @Input() config: SkeletonConfig;

  @HostBinding('style.width') get hostWidth() {
    return this.config?.customWidth || '100%';
  }

  get hostHeight() {
    return this.config?.customHeight || '400px';
  }
}
